var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import Shimmer from '../../../LoadingShimmer/LoadingShimmer';
import Text from '../../../Text';
var BodyWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var size = _a.size;
    var isTile = size === 'tile';
    var padding = isTile ? '16px' : '12px 16px 16px';
    return "padding: ".concat(padding, ";");
});
var ContentTextWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var size = _a.size;
    switch (size) {
        case 'tile':
            return 'margin-top: 12px';
        default:
            return 'margin-top: 4px';
    }
});
var CustomCardBodyContentLoading = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 12px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"], ["\n  padding: 12px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"])));
var CustomCardBodyContent = function (props) {
    var bodyContent = props.bodyContent, label = props.label, size = props.size, loading = props.loading;
    var labelToRender = label;
    if (typeof label === 'string') {
        labelToRender = (_jsx(Text, __assign({ variant: "h6", isTermina: false }, { children: label })));
    }
    return (_jsxs(BodyWrapper, __assign({ size: size }, { children: [!loading && labelToRender, !loading && bodyContent && (_jsxs(ContentTextWrapper, __assign({ size: size }, { children: [typeof bodyContent === 'string' && _jsx(Text, __assign({ variant: "body2Medium" }, { children: bodyContent })), typeof bodyContent !== 'string' && bodyContent] }))), loading && (_jsxs(CustomCardBodyContentLoading, { children: [_jsx(Shimmer, { width: 140 }), _jsx(Shimmer, {})] }))] })));
};
export default CustomCardBodyContent;
var templateObject_1, templateObject_2, templateObject_3;
